export const listItemSpinnerConfig = {
  lines: 13,
  length: 10,
  width: 3,
  radius: 10,
  color: '#413675',
  speed: 0.7
};
